var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16","width":"16","height":"16"}},[_c('path',{attrs:{"stroke":"#9999A9","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","d":"M11.714 2.838a6.276 6.276 0 1 1-8.876 8.876 6.276 6.276 0 0 1 8.876-8.876M15 15l-3.29-3.29"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }